// Strings for S1. Only the S1 worker edits this file (see web/README.md).
// Copy from prototype/index.html and assets/app.js; DRAFT = no source there (w2-03 report).
export default {
  title: 'Where did you fly?',
  sub: 'Type a city, an airport or its code.',
  scanNotice: 'We read part of your boarding pass — check the fields below.',
  'from.label': 'Departure airport',
  'from.placeholder': 'Barcelona, BCN…',
  'to.label': 'Arrival airport',
  'to.labelFinal': 'Final destination',
  'to.placeholder': 'London, LHR…',
  'via.label': 'Where did you change planes?',
  'via.placeholder': 'Frankfurt, FRA…',
  'via.remove': 'Remove connection {n}',
  addConnection: 'Add a connection',
  noMatch: 'No airport matches that.',
  // DRAFT (w5-03): the search itself failed, which is not "no match".
  searchDown: "Airport search isn't working right now — that's on our side. Try again in a minute.",
  searchOffline: "We couldn't search just now. Check your connection and try again.",
  searchRetry: 'Try again',
  hint: "No flight number needed — we'll show you every flight on this route.",
  sameAirport: 'Two airports in a row are the same — check the route.', // DRAFT

  // The rule-8 summary card on S3–S6 (shared by the eligibility stage)
  'summary.via': 'via {via}',
  'summary.editRoute': 'Edit route and date', // DRAFT (accessible name; visible text is "Edit")
  'summary.editFlight': 'Edit flight', // DRAFT (accessible name; visible text is "Edit")

  // The enquiry can't be opened (e.g. 403): no copy in the spec
  'stageError.title': "We couldn't open this check", // DRAFT
  'stageError.body':
    'It may have been started in another browser. You can start a new one — it takes a minute.', // DRAFT
  'stageError.cta': 'Start a new check', // DRAFT
} as const;
